//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapGetters,
} from 'vuex';
import VueRouter from 'vue-router';
import DashboardPlanejamento from './DashboardPlanejamento';
import DashboardNegociacao from './DashboardNegociacao';
import DashboardApuracao from './DashboardApuracao';
import DashboardPagamento from './DashboardPagamento';
import DashboardAcompanhamento from './acompanhamento/DashboardAcompanhamento';
import ExecucaoSidebarApuracao from '../../../../../shared-components/sidebar/ExecucaoSidebar';

export default {
  data() {
    return {
      dashboardOrcamentoResources: this.$api.dashboardOrcamento(this.$resource),
      valor: null,
      currentData: null,
      exibiuPlanejamento: false,
      exibiuNegociacao: false,
      exibiuApuracao: false,
      exibiuPagamento: false,
      exibiuAcompanhamento: false,
      parametros: null,
      dashboardCarregado: false,
      index: null,
      apuracaoEmit: {},
    };
  },
  mounted() {
    if (this.carregamentoCliente()) {
      this.setTabCliente();
    } else if (this.carregamentoParametro()) {
      this.setTabPorUrl();
    } else {
      this.setTabPorPermissao();
    }
  },
  components: {
    DashboardPlanejamento,
    DashboardNegociacao,
    DashboardApuracao,
    DashboardPagamento,
    DashboardAcompanhamento,
    VueRouter,
    ExecucaoSidebarApuracao,
  },
  methods: {
    abrirSideBarApuracao(eventData) {
      this.apuracaoEmit = eventData;
      this.$refs.apuracaoExecSidebar.toggle();
    },
    fecharSideBarApuracao() {
      this.apuracaoEmit.fecharSideBar();
    },
    carregamentoCliente() {
      return this.getAllRoles.indexOf('DASH_OPER_CLIENTE') !== -1;
    },
    carregamentoParametro() {
      return this.$el.baseURI.indexOf('tab') !== -1;
    },
    setTabPorPermissao() {
      let index = null;
      if (this.podeAcessarDashboardOrcamento) {
        index = 0;
      } else if (this.podeAcessarDashboardNegociacao) {
        index = 1;
      } else if (this.podeAcessarDashboardApuracao) {
        index = 2;
      } else if (this.podeAcessarDashboardPagamento) {
        index = 3;
      }
      if (index === null) {
        return;
      }

      setTimeout(() => {
        this.dashboardCarregado = true;
        this.setTab(index);
      });
    },
    setTabCliente() {
      this.parametros = this.extrairParametrosUrl();
      setTimeout(() => {
        this.dashboardCarregado = true;
        this.setTab(4);
      });
    },
    setTabPorUrl() {
      let index = null;
      this.parametros = this.extrairParametrosUrl();

      if (this.parametros.tab === 'negociacao' && this.podeAcessarDashboardNegociacao) {
        index = 1;
      } else if (this.parametros.tab === 'apuracao' && this.podeAcessarDashboardApuracao) {
        index = 2;
      } else if (this.parametros.tab === 'pagamento' && this.podeAcessarDashboardPagamento) {
        index = 3;
      } else if (this.podeAcessarDashboardOrcamento) {
        index = 0;
      }

      if (index === null) {
        return;
      }

      setTimeout(() => {
        this.dashboardCarregado = true;
        this.setTab(index);
      });
    },
    setTab(index) {
      if (!this.dashboardCarregado) {
        return;
      }

      if (index === 0) {
        this.exibiuPlanejamento = true;
        this.$refs.mdTab.activeTab = 'orcamento';
        this.$refs.mdTab.activeTabNumber = 0;
      } else if (index === 1) {
        this.exibiuNegociacao = true;
        this.$refs.mdTab.activeTab = 'negociacao';
        this.$refs.mdTab.activeTabNumber = 1;
      } else if (index === 2) {
        this.exibiuApuracao = true;
        this.$refs.mdTab.activeTab = 'apuracao';
        this.$refs.mdTab.activeTabNumber = 2;
      } else if (index === 3) {
        this.exibiuPagamento = true;
        this.$refs.mdTab.activeTab = 'pagamento';
        this.$refs.mdTab.activeTabNumber = 3;
      } else if (index === 4) {
        this.exibiuAcompanhamento = true;
        this.$refs.mdTab.activeTab = 'acompanhamento';
        this.$refs.mdTab.activeTabNumber = 4;
      }
      this.index = index;
      this.abreCarrega();
    },
    abreCarrega() {
      const ref = `dash-${this.$refs.mdTab.activeTab}`;
      this.$refs[ref].abreCarrega();
    },
    extrairParametrosUrl() {
      return this.$router.currentRoute.query || {};
    },
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    ...mapGetters('controlador', [
      'getControladoreSelecionado',
    ]),
    canAccessPage() {
      return this.podeAcessarDashboardOrcamento || this.podeAcessarDashboardNegociacao ||
        this.podeAcessarDashboardApuracao || this.podeAcessarDashboardPagamento ||
        this.podeAcessarAcompanhamento;
    },
    podeAcessarDashboardOrcamento() {
      if (!this.getAllRoles || this.carregamentoCliente()) {
        return false;
      }
      return this.getAllRoles.indexOf('DASH_OPER_ORC') >= 0;
    },
    podeAcessarDashboardNegociacao() {
      if (!this.getAllRoles || this.carregamentoCliente()) {
        return false;
      }
      return this.getAllRoles.indexOf('DASH_OPER_NEG') >= 0;
    },
    podeAcessarDashboardApuracao() {
      if (!this.getAllRoles || this.carregamentoCliente()) {
        return false;
      }
      return this.getAllRoles.indexOf('DASH_OPER_APURACAO') >= 0;
    },
    podeAcessarDashboardPagamento() {
      if (!this.getAllRoles || this.carregamentoCliente()) {
        return false;
      }
      return this.getAllRoles.indexOf('DASH_OPER_PGTO') >= 0;
    },
    podeAcessarAcompanhamento() {
      if (!this.getAllRoles || !this.carregamentoCliente()) {
        return false;
      }
      return this.getAllRoles.indexOf('DASH_OPER_CLIENTE') >= 0;
    },
  },
  beforeDestroy() {
    window.hitDestroy = new Date().getTime();
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/DashBoard.vue?vue&type=script&lang=js&